import React, {Component} from 'react';
import I18n from 'app/i18n';
import LotsForSaleTable from './lots_for_sale_table';
import {inject, observer} from 'mobx-react';
import {modalConfirm} from 'app/utils/modals/popups';
import {artifactName} from 'app/components/my_profile/artifacts/utils';
import {sellOrderStore} from 'app/store/global';
import SmartLoader from 'app/components/reusable/SmartLoader';

export default inject('sellOrderStore')(observer(class SellOrders extends Component {
    handleLoadMore = () => this.props.sellOrderStore.loadMore();

    componentDidMount = () => {
        this.handleLoadMore()
            .promise(() => this.props.sellOrderStore.setLoadingTo(true));
    };

    componentWillUnmount = () => this.props.sellOrderStore.reset();

    cancelOrder = (artifact, id) => modalConfirm(I18n.t(
        'remove_sell_artifact_order_confirm',
        {artifact: artifactName(artifact)}
    ), () => sellOrderStore.delete(id));

    render() {
        const {loading, count, asJson} = this.props.sellOrderStore;
        return <div className="market__lots">
            <div className="market__lots-count">
                {I18n.t('my_lots_for_sale')}
                <span>({count})</span>
            </div>

            {loading
                ? <div className="table-more">
                    <SmartLoader/>
                </div>
                : <LotsForSaleTable
                    {...asJson}
                    handleLoadMore={this.handleLoadMore}
                    cancelOrder={this.cancelOrder}
                    noLotsLabel={I18n.t('there_are_no_active_lots')}
                />}
        </div>;
    }
}));
